<template>
  <div class="corss-sell container">
        <CrossSaleContainer :orderID="orderID" :productID="productID" />
  </div>
</template>

<script setup lang="ts">

import CrossSaleContainer from "./crossSaleContainer.vue";
import { useRoute } from "vue-router";

const route = useRoute();

// Get from URL first, then fall back to localStorage
const productID = (route.query.productID as string) || localStorage.getItem('productID') || "";
const orderID = (route.query.orderID as string) || localStorage.getItem('orderID') || "";

</script>

<style lang="scss" scoped>

</style>